import { projectSubTypeAdapter } from "./project-subtype.state";
import { initialProjectTypeState } from "./project-subtype.state";
import { createReducer, on } from "@ngrx/store";
import { ProjectSubTypeActions } from "./project-subtype.actions";

export const projectSubTypeReducer = createReducer(
    initialProjectTypeState,
    on(ProjectSubTypeActions.loadProjectSubTypeSuccess, (state, action) => {
        return projectSubTypeAdapter.setAll(action.projectSubTypes, {
            ...state,
            errorMessage: null
        });
    }),
    on(ProjectSubTypeActions.addProjectSubTypeSuccess, (state, { projectSubType }) => {
        return projectSubTypeAdapter.addOne(projectSubType, {
            ...state,
            errorMessage: null
        });
    }),
    on(ProjectSubTypeActions.updateProjectSubTypeSuccess, (state, { projectSubType }) => {
        if (!projectSubType.projectSubTypeId) {
            return {
                ...state,
                errorMessage: "projectSubTypeId is required for update"
            };
        }
        return projectSubTypeAdapter.updateOne({ id: projectSubType.projectSubTypeId, changes: projectSubType }, {
            ...state,
            errorMessage: null
        });
    }),
    on(ProjectSubTypeActions.deleteProjectSubType, (state, { projectSubTypeId }) => {
        return projectSubTypeAdapter.removeOne(projectSubTypeId, {
            ...state,
            errorMessage: null
        });
    }),
);